import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaArrowAltCircleRight, FaFileDownload } from 'react-icons/fa';
import { ButtonCloseModal } from 'shared-pages/components';
import { ImportFieldHelp } from './ImportFieldHelp';
import 'shared-pages/pages/collections/grid/import-from-excel/import-progress.css';

interface PreImportModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onDownloadTemplate?: () => void;
}

export const PreImportModal: React.FC<PreImportModalProps> = ({
  show,
  onClose,
  onSubmit,
  onDownloadTemplate,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} centered size="xl" backdrop="static" className="ip-modal">
      <Form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <Modal.Header className="ip-modal-header">
          <Modal.Title className="ip-modal-title">
            {t('Εισαγωγή Σημείων Συλλογής από Excel')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '0 0 var(--ip-border-radius) var(--ip-border-radius)',
            padding: 'var(--ip-spacing-lg)',
            fontSize: '0.9rem',
          }}
        >
          <div className="d-flex justify-content-between align-items-start mb-3">
            <p className="text-muted small mb-0">
              {t(
                'Ελέγξτε τις στήλες του αρχείου και πατήστε «Έναρξη». Η ταυτοποίηση των σημείων γίνεται βάσει της επωνυμίας. Αν εντοπιστεί υπάρχον σημείο, τα στοιχεία του ενημερώνονται· διαφορετικά, καταχωρείται νέο. Με την ολοκλήρωση της διαδικασίας, θα λάβετε αρχείο με το αποτέλεσμα για κάθε γραμμή.',
              )}
            </p>
            {onDownloadTemplate && (
              <Button
                variant="outline-secondary"
                size="sm"
                className="text-nowrap ms-3 flex-shrink-0"
                onClick={onDownloadTemplate}
                type="button"
              >
                <FaFileDownload className="mb-1 me-1" />
                {t('Λήψη προτύπου')}
              </Button>
            )}
          </div>

          <ImportFieldHelp />
        </Modal.Body>

        <Modal.Footer
          className="ip-modal-footer"
          style={{
            borderTop: '1px solid var(--ip-border-color)',
            paddingTop: 'var(--ip-spacing-md)',
            backgroundColor: '#fff',
          }}
        >
          <div className="d-flex justify-content-between w-100 align-items-center">
            <ButtonCloseModal onClick={onClose} />

            <Button
              variant="info"
              type="submit"
              className="px-4 shadow-sm"
              style={{
                backgroundColor: 'var(--ip-success)',
                border: 'none',
                color: '#fff',
                borderRadius: 'var(--ip-border-radius)',
                fontWeight: 600,
                letterSpacing: '0.3px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              }}
            >
              <FaArrowAltCircleRight className="mb-1" />
              &nbsp;
              {t('Έναρξη εισαγωγής')}
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
